const initialState = {
  proposalList: [],
  responseHeaders: '',
  proposalDetail: [],
  proposalError: ''
};

const MyProposalReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'MY_PROPOSAL_DATA':
      return {
        ...state,
        proposalList: action.payload,
        responseHeaders: action.headers
      };
    case 'PROPOSAL_DOC':
    case 'EMPTY_PROPOSAL_DOC':
      return {
        ...state,
        proposalDetail: action.payload
      };
    case 'PROPOSAL_ERROR':
      return {
        ...state,
        proposalError: action.errorMsg
      };
    default:
      return state;
  }
};

export default MyProposalReducer;
